export default __webpack_public_path__ + "static/media/Demacia_Crest.e93c584a.png";